import { render, staticRenderFns } from "./PedidoSingle.vue?vue&type=template&id=b35cdd48&scoped=true&lang=pug"
import script from "./PedidoSingle.vue?vue&type=script&lang=js"
export * from "./PedidoSingle.vue?vue&type=script&lang=js"
import style0 from "./PedidoSingle.vue?vue&type=style&index=0&id=b35cdd48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35cdd48",
  null
  
)

export default component.exports